import { render, staticRenderFns } from "./wtAddComment.component.vue?vue&type=template&id=04174a8a&"
import script from "./wtAddComment.component.vue?vue&type=script&lang=js&"
export * from "./wtAddComment.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports